export const PARENT_ID = 'hubspot-messages-iframe-container';
export const INLINE_PARENT_ID = 'hubspot-conversations-inline-parent';
export const INLINE_IFRAME_ID = 'hubspot-conversations-inline-iframe';
export const IFRAME_ID = 'hubspot-conversations-iframe';